<template>
	<el-dialog title="更新重量" :visible.sync="dialogupdateweight" width="450px" append-to-body :close-on-click-modal="false">
		<div class="updateweight" style="height:100px;">
			<el-row style="padding-top:40px">
				<el-col :span="4" style="color:transparent">1</el-col>
				<el-col :span="15">
					<span>重量差额</span>
					<el-input type="number" size="mini" v-model="weightrange" style="width:150px;margin-left:10px"></el-input>
				</el-col>
			</el-row>
			<el-row style="height:20px"></el-row>
		</div>
		<span slot="footer" class="dialog-footer">
			<div style="text-align: center;width:100%">
				<el-button size="mini" type="success" @click.native="updateweight">确认更新</el-button>
				<el-button size="mini" type="info" plain @click.native="dialogupdateweight = false">关闭</el-button>
			</div>
		</span>
	</el-dialog>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	props: {},
	data() {
		return {
			batch: '',
			dialogupdateweight: false,
			weightrange: localStorage.getItem('weightrange'),
			searchinfo: '',
			pageparam: {},
			userid:localStorage.getItem('userid')
		};
	},
	mounted() {},
	methods: {
		init(param) {
			this.batch = '';
			this.searchinfo = '';
			if (param.searchinfo != undefined) this.searchinfo = param.searchinfo;
			if (param.batch != undefined) this.batch = param.batch;
			this.pageparam = param.pageparam;
			this.dialogupdateweight = true;
		},
		//更新重量,
		updateweight() {
			var that = this;
			if (that.weightrange != '') {
				this.$tool.loading('正在更新', 'updateweight');
				this.$apipost.post.UpdateWeight({ paraminfo: this._data }).then(res => {
					this.$tool.loadingclose();
					if (res.state == '1') {
						that.batch = res.batch;
						this.$tool.message(res.message, 1);
						that.dialogupdateweight = false;
						localStorage.setItem('weightrange', that.weightrange);
					} else if (res.state == '2') {
						that.batch = res.batch;
						//下载未更新的订单
						this.$tool.message(res.message, 0);
						this.$tool.downfile(that, res.filename);
						localStorage.setItem('weightrange', that.weightrange);
					} else {
						this.$tool.message(res.message, 0);
					}
				});
			}
		}
	}
};
</script>
